import { createFileRoute } from "@tanstack/react-router";
import SpravatoGoogle from "@/pages/SpravatoGoogle";
export const Route = createFileRoute("/spravato-google")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "SPRAVATO® in Coral Springs, FL | Certified REMS Center",
        },
        {
          name: "description",
          content:
            "FDA-approved SPRAVATO® (esketamine) for treatment-resistant depression. Certified REMS center in Coral Springs, FL. Check your eligibility — it takes two.",
        },
        {
          property: "og:title",
          content: "SPRAVATO® in Coral Springs, FL | Certified REMS Center",
        },
        {
          property: "og:description",
          content:
            "FDA-approved SPRAVATO® (esketamine) for treatment-resistant depression. Certified REMS center in Coral Springs, FL. Check your eligibility — it takes two.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-google",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-google",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoGoogle />;
}
